<template>
  <div>
    <b-modal
      id="saveManualPayment"
      title="تسویه دستی"
      ok-title="ذخیره"
      cancel-title="لغو"
      @ok="SaveManual"
    >
      <b-form-group label="حساب مقصد:">
        <v-select-shepa
          dir="rtl"
          :options="usercards"
          :reduce="(item) => item.value"
          label="text"
          :value="manualItem.detailed_id"
          v-model="manualItem.detailed_id"
          :autocomplete="'on'"
        ></v-select-shepa>
      </b-form-group>
      <b-form-group label="مبلغ:">
        <b-form-input v-model="manualItem.amount"></b-form-input>
      </b-form-group>
      <b-form-group label="حساب مقصد:">
        <b-form-select
          v-model="manualItem.bank_detailedid"
          :options="banks"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="کد رهگیری:">
        <b-form-input v-model="manualItem.tracking_number"></b-form-input>
      </b-form-group>
    </b-modal>

    <list-table
      :url="url"
      title="بستانکاران شپا"
      :fields="fields"
      :params="params"
      :sumPrice="true"
      
      :back="false"
    ></list-table>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";
import httpHelper from "@/helpers/httpHelper";
import TableShowData from "@/components/table";

export default {
  name: "bankDeposit",
  data() {
    return {
      url: "creditors",
      transactions_created_at: "",
      totlaBalanc: 0,
      usercards: [],
      banks:[],
      gatewayId:0,
      manualItem: {
        detailed_id: 0,
        amount: 0,
        bank_detailedid: 0,
        tracking_number: "",
      },
      //anotherUrl:{SAD:'saderat/get-balance',SAM:'saman/deposit-balance'},
      params: [
        {
          label: "موجودی بانک سامان",
          field: "BalanceSaman",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک سامان 2",
          field: "BalanceSaman2",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات",
          field: "BalanceSaderat",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک ملی",
          field: "BalanceMeli",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی کل:",
          field: "TotalBalance",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "تا تاریخ",
          field: "date",
          type: "date-picker",
          value: "",
        },
        {
          label: "تا ساعت",
          field: "time",
          type: "text",
          value: "",
        },
      ],
      fields: [
        {
          key: "gateway.user.name",
          label: "نام پذیرنده",
        },

        {
          key: "gateway.website",
          label: "وب سایت",
        },
        {
          key: "amount",
          label: "مانده حساب (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            if (item.amount < 0) {
              return "بدهکار";
            } else {
              return "بستانکار";
            }
          },
        },
        
      ],
     
    };
  },
  components: {
    "list-table": TableShowData,
    "v-select-shepa":vSelect,
  },
  watch: {
    totlaBalanc(newB, oldB) {
      this.params[3].value = Number(newB).toLocaleString() + " ریال";
    },
  },
  computed: {},
  methods: {
    SaveManual() {
      console.log(this.manualItem);
      httpHelper.postData('sharing/save_manual_transfer/' + this.gatewayId , this.manualItem)
      .then(res=>{
        this.url = "creditors?t=" + new Date().getTime();
      });
      this.$bvModal.hide('saveManualPayment');
    },
    loadedBalanceSam() {
      this.$store.dispatch(GET_BANK_LIST).then(loadedBankList => {
        console.log("loadedBankList:",loadedBankList);
        loadedBankList.forEach((element, index) => {
          httpHelper
            .getData(`sharing/get_balance/${element.title}`)
            .then((res) => {
              if (!res.result.url.match("https://")) {
                this.totlaBalanc += res.result.balance;
                this.params[index].value =
                  Number(res.result.balance).toLocaleString() + " ریال";
              } else {
                this.$makeToast(
                  "danger",
                  "مشاهده موجودی بانک ملی",
                  "برای مشاهده موجودی اینجا کلیک کنید.",
                  7000,
                  res.result.url
                );
              }
            });
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "موجودی بانک",
      },
    ]);
    httpHelper.getData("sharing/banks").then((res) => {
      this.banks = res.result.map(element => {
        return {
          text: element.fa_title,
          value: element.detail_id,
        };
      });
    });
    this.loadedBalanceSam();
  },
};
</script>